var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OButton',_vm._g(_vm._b({staticClass:"bg-o-blue text-white w-full font-bold h-12 sm:h-16 sm:text-xl rounded",attrs:{"pure":""}},'OButton',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.$t('news-page.show-comments'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }